import DomainTable from './DomainTable'

export { columns } from './DomainTable'
export default DomainTable
